import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccessDocAndFileComponent } from './access-doc-and-file/access-doc-and-file.component';
import { AspxComponent } from './aspx/aspx.component';
import { CalculHeightPipe, CodePostalComponent } from './codePostal/codepostal.component';
import { CoupleComponent } from './couple/couple.component';
import { EmailComponent } from './email/email.component';
import { ImageSelectComponent } from './imageSelect/image-select.component';
import { NumeringComponent } from './numering/numering.component';
import { SearchSelectComponent } from './SearchSelect/searchselect.component';
import { TexthistoriqueComponent } from './texthistorique/texthistorique.component';
import { TimeComponent } from './time/time.component';
import { CheckBoxSelectComponent } from './checkBoxSelect/checkboxselect.component';
import { CabinetComponent } from './cabinet/cabinet.component';
import { PipeModule } from '../../../pipes/pipe.module';
import { SelectModule } from '../../../select/select.module';
import { InseeComponent } from './insee/insee.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { CycleElearningComponent } from './datepicker/cycle-elearning/cycle-elearning.component';
import { VideoZoomComponent } from './video-zoom/video-zoom.component';
import { ElearningChaptersComponent } from './elearning-chapters/elearning-chapters.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { AckkeyComponent } from './ackkey/ackkey.component';
import { BoFindComponent } from './boFind/bofind.component';
import { DateModule } from '../../../date';
import { CustomgridModule } from '../../../customgrid';
import { GEDModule } from '../../../gestion-electronique-documents';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InsertDocInputModule } from '../../../insertdoc/insertdoc-input';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { SearchAgGridComponent } from './search-ag-grid/search-ag-grid.component';
import { AccesPortailModule } from '../../../acces-portail/acces-portail.module';
import { AdminAccesPortailComponent } from './admin-acces-portail/admin-acces-portail.component';
import { RumSepaComponent } from './rum-sepa/rum-sepa.component';

@NgModule({
  imports: [
    CKEditorModule,
    CommonModule,
    FormsModule,
    NgbModule,
    PipeModule,
    SelectModule,
    NgbModule,
    DateModule,
    CustomgridModule,
    GEDModule,
    InsertDocInputModule,
    ScrollingModule,
    AccesPortailModule,
  ],
  declarations: [
    TextEditorComponent,
    AccessDocAndFileComponent,
    AdminAccesPortailComponent,
    AspxComponent,
    CodePostalComponent,
    AckkeyComponent,
    CoupleComponent,
    EmailComponent,
    ImageSelectComponent,
    NumeringComponent,
    SearchSelectComponent,
    TexthistoriqueComponent,
    TimeComponent,
    CheckBoxSelectComponent,
    CabinetComponent,
    InseeComponent,
    DatepickerComponent,
    CycleElearningComponent,
    VideoZoomComponent,
    BoFindComponent,
    ElearningChaptersComponent,
    CalculHeightPipe,
    SearchAgGridComponent,
    RumSepaComponent,
  ],
  exports: [
    TextEditorComponent,
    AccessDocAndFileComponent,
    AdminAccesPortailComponent,
    AspxComponent,
    CodePostalComponent,
    AckkeyComponent,
    CoupleComponent,
    EmailComponent,
    ImageSelectComponent,
    NumeringComponent,
    SearchSelectComponent,
    TexthistoriqueComponent,
    TimeComponent,
    CheckBoxSelectComponent,
    CabinetComponent,
    InseeComponent,
    DatepickerComponent,
    CycleElearningComponent,
    VideoZoomComponent,
    BoFindComponent,
    ElearningChaptersComponent,
    SearchAgGridComponent,
    RumSepaComponent,
  ]
})

export class DynamicTagAddonModule { }
